import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/teacher-account";

export function getTeacher(teacherId) {
  return axios.get(`${BASE}/teacher/${teacherId}`);
}

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

/**
 * Create a teacher account entry.
 * For payouts, pass FormData with fields + file (signed receiving form image).
 * For manual_credit, pass a plain object (JSON).
 */
export function create(data) {
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    return axios.post(BASE, data);
  }
  return axios.post(BASE, data);
}

export function softEdit(id, data) {
  return axios.post(`${BASE}/${id}/soft-edit`, data);
}
